@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.global-e-message {
  color: @fulfillment-planner--restricted-shipment--info--text-color;
}
